import React from "react";
import { singularPlural } from "../../../common/utils/time.formatted.util";
import Label from "../../Common/Label";
import { ScoreTag } from "../../Common/Tag";

type Props = {
    label: string;
    reviews:
        | {
              rating: number | null | undefined;
              reviewsTotal: number | null | undefined;
              googlePlaceId: string | undefined;
          }
        | undefined;
};

function GoogleReview(props: Props) {
    const { label, reviews } = props;

    return reviews?.rating ? (
        <>
            <Label.Small.SemiBold>{label}</Label.Small.SemiBold>
            <ScoreTag
                ratingScore={{
                    average: reviews.rating,
                }}
            />

            {reviews.reviewsTotal ? (
                <a
                    href={`https://search.google.com/local/reviews?placeid=${reviews.googlePlaceId}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Label.XSmall.SemiBold.N50>
                        {singularPlural(
                            `${reviews.reviewsTotal} review`,
                            `${reviews.reviewsTotal} reviews`,
                            reviews.reviewsTotal,
                        )}
                    </Label.XSmall.SemiBold.N50>
                </a>
            ) : (
                <Label.XSmall.SemiBold.N50>No reviews yet</Label.XSmall.SemiBold.N50>
            )}
        </>
    ) : (
        <Label.XSmall.SemiBold.N60>Google rating unavailable</Label.XSmall.SemiBold.N60>
    );
}

export default GoogleReview;
